export default __webpack_public_path__ + "static/media/topics.a51a7de3.png";